<mat-card class="{{ level }} mat-elevation-z0" [style.max-width]="maxWidth">
  <mat-card-content>
    @if (!hideTitle) {
      <div class="info-card-title">
        <mat-icon>{{ level }}</mat-icon>
        <div>{{ title || (level | titlecase) | translate: locale.language }}</div>
      </div>
    }
    @if (message) {
      {{ message | translate: locale.language }}
    }
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
